import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Autocomplete,
  Checkbox,
  Dialog,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { getAllTaxSettingsListAPICall } from "../../../../../API/Settings/TaxSettings/taxSettingsAPI";
import { useSelector } from "react-redux";
import { AddTaxPopupApiCall } from "../inventoryProductsAPI";

function EditProductTaxPopup({ open, onClose, product, onSuccess }) {
  const taxListFull = useSelector((state) => state.taxSettingsSlice.value);

  const [formValues, setFormValues] = useState({
    vendorTax: [],
    customerTax: [],
    nonTaxable: false,
  });

  useEffect(() => {
    getAllTaxSettingsListAPICall();
  }, []);

  useEffect(() => {
    if (product && taxListFull) {
      const vendorTaxObjs = (product.vendorTax || [])
        .map((id) => taxListFull.find((t) => t._id === id || t._id === id?.toString()))
        .filter(Boolean);
      const customerTaxObjs = (product.customerTax || [])
        .map((id) => taxListFull.find((t) => t._id === id || t._id === id?.toString()))
        .filter(Boolean);
      setFormValues({
        vendorTax: vendorTaxObjs,
        customerTax: customerTaxObjs,
        nonTaxable: product.nonTaxable || false,
      });
    }
  }, [product, taxListFull]);

  const handleTaxChange = (key) => (event, newValue) => {
    setFormValues({ ...formValues, [key]: newValue });
  };

  const buildPayload = (applyAll) => ({
    productIdList: applyAll ? [] : [product._id],
    mainCatgeoryId: "",
    poscat: "",
    vendorTax: formValues.vendorTax.map((tax) => tax._id) || [],
    customerTax: formValues.customerTax.map((tax) => tax._id) || [],
    nonTaxable: formValues.nonTaxable,
    allProducts: applyAll,
  });

  const handleSubmit = () => {
    AddTaxPopupApiCall(buildPayload(false));
    onClose();
    if (onSuccess) onSuccess();
  };

  const handleApplyAll = () => {
    if (window.confirm("Are you sure you want to apply this tax to ALL products?")) {
      AddTaxPopupApiCall(buildPayload(true));
      onClose();
      if (onSuccess) onSuccess();
    }
  };

  if (!product) return null;

  return (
    <Dialog open={open} maxWidth="sm" onClose={onClose} fullWidth>
      <div style={{ padding: "20px" }}>
        <h4 style={{ margin: "0 0 5px 0" }}>{product?.name}</h4>
        <p style={{ margin: "0 0 15px 0", color: "#888", fontSize: "13px" }}>{product?.prodId}</p>
        <hr style={{ margin: "0 0 15px 0", border: "none", borderTop: "1px solid #eee" }} />

        <FormControlLabel
          control={
            <Checkbox
              checked={formValues.nonTaxable}
              onChange={(e) => setFormValues({ ...formValues, nonTaxable: e.target.checked })}
            />
          }
          label="Non Taxable"
        />

        <div className="global-input-field-container" style={{ marginTop: "10px" }}>
          <div className="global-single-input auto-complete">
            <p>Vendor Tax</p>
            <Autocomplete
              multiple
              options={
                taxListFull
                  ?.filter((obj) => obj?.taxType === "Purchase")
                  ?.filter(
                    (option) =>
                      !formValues?.vendorTax?.length ||
                      option?.includedPrice === formValues?.vendorTax[0]?.includedPrice
                  ) || []
              }
              getOptionLabel={(option) => option?.taxName}
              renderOption={(props, option) => (
                <li {...props} key={option._id}>
                  <span>{option.taxName}</span>
                </li>
              )}
              renderInput={(params) => <TextField {...params} />}
              value={formValues?.vendorTax}
              onChange={handleTaxChange("vendorTax")}
              disabled={formValues.nonTaxable}
            />
          </div>
          <div className="global-single-input auto-complete">
            <p>Customer Tax</p>
            <Autocomplete
              multiple
              options={
                taxListFull
                  ?.filter((obj) => obj?.taxType === "Sales")
                  ?.filter(
                    (option) =>
                      !formValues?.customerTax?.length ||
                      option?.includedPrice === formValues?.customerTax[0]?.includedPrice
                  ) || []
              }
              getOptionLabel={(option) => option?.taxName}
              renderOption={(props, option) => (
                <li {...props} key={option?._id}>
                  <span>{option?.taxName}</span>
                </li>
              )}
              renderInput={(params) => <TextField {...params} />}
              value={formValues?.customerTax}
              onChange={handleTaxChange("customerTax")}
              disabled={formValues.nonTaxable}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
            gap: "10px",
          }}
        >
          <button className="btn btn-secondary-outlined" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            style={{ backgroundColor: "#ff9800", borderColor: "#ff9800" }}
            onClick={handleApplyAll}
          >
            Apply to All Products
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Update
          </button>
        </div>
      </div>
    </Dialog>
  );
}

EditProductTaxPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  product: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default EditProductTaxPopup;
